<template>
    <v-container>
      <v-card>
  <v-card-title class="white grey--text text--darken-3">
    <v-icon left color="grey darken-3">mdi-cash-refund</v-icon>
    Pending Withdrawals
    <v-spacer></v-spacer>
    <v-btn color="success" @click="refreshData">
      <v-icon left>mdi-refresh</v-icon>
      Refresh
    </v-btn>
  </v-card-title>

  
        <v-data-table
          :headers="headers"
          :items="withdrawals"
          :loading="loading"
        >
          <template v-slot:item.actions="{ item }">
            <div class="d-flex">
              <v-btn 
                small 
                color="success" 
                @click="updateStatus(item.transaction_id, 'COMPLETED')"
                class="mr-2"
              >
                <v-icon small>mdi-check</v-icon>
                Approve
              </v-btn>
              <v-btn 
                small 
                color="error" 
                @click="updateStatus(item.transaction_id, 'REJECTED')"
              >
                <v-icon small>mdi-close</v-icon>
                Reject
              </v-btn>
            </div>
          </template>
  
          <template v-slot:item.amount="{ item }">
            {{ item.amount }} FCFA
            <v-chip small color="red lighten-5" class="ml-2">
              Fee: {{ item.fee }} FCFA
            </v-chip>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </template>
  
  <script>
  import axios from 'axios'
  export default {
    data: () => ({
      headers: [
        { text: 'Transaction ID', value: 'transaction_id' },
        { text: 'User', value: 'user' },
        { text: 'Amount', value: 'amount' },
        { text: 'Date', value: 'date' },
        { text: 'Phone', value: 'phone' },
        { text: 'Actions', value: 'actions' }
      ],
      withdrawals: [],
      loading: false
    }),
  
    async mounted() {
      await this.loadData()
    },
  
    methods: {
      async loadData() {
        this.loading = true
        try {
          const response = await axios.get('/api/v1/home/withdrawals/approvals/')
          this.withdrawals = response.data
        } catch (error) {
          this.handleError(error)
        } finally {
          this.loading = false
        }
      },
  
      async updateStatus(transactionId, status) {
        try {
          await axios.patch(`/api/v1/home/withdrawals/${transactionId}/`, { status })
          this.$store.commit('setSnackbar', {
            message: `Withdrawal ${status.toLowerCase()} successfully`,
            color: 'success',
            show: true
          })
          await this.loadData()
        } catch (error) {
          this.handleError(error)
        }
      },
  
      async refreshData() {
        await this.loadData()
      },
  
      handleError(error) {
        const message = error.response?.data?.error || 'An error occurred'
        this.$store.commit('setSnackbar', {
          message,
          color: 'error',
          show: true
        })
      }
    }
  }
  </script>
  
  <style scoped>
  .v-data-table >>> .v-chip {
    height: 24px;
    font-size: 0.8rem;
  }
  </style>